import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import Link from '../../../components/link';
import { LoadingIcon } from '../../../components/loading';

const BatchList = (props) => {
  const { t } = props;
  const columns = [
    {
      title: t('type'),
      dataIndex: 'type',
      filters: [
        {
          text: t('batch.type.internal'),
          value: 'internal',
        },
        {
          text: t('batch.type.external'),
          value: 'external',
        },
      ],
      onFilter: (value, { type }) => value === (type || 'internal'),
      width: 100,
      render: (value) => t(`batch.type.${value || 'internal'}`),
    },
    {
      title: t('description'),
      dataIndex: 'description',
      render: (desc, record) => <Link to={`/accounts/${record.account_id}/batches/${record.id}`}>{desc}</Link>,
    },
    {
      title: t('status'),
      dataIndex: 'completed',
      width: 150,
      render: (value) => t(`batch.status.${(value) ? 'completed' : 'pending'}`),
    },
    {
      title: t('created_at'),
      dataIndex: 'created_at',
      width: 200,
      render: (created_at) => ((created_at) ? moment(created_at).format('lll') : ''),
      sorter: (a, b) => moment(a.created_at) - moment(b.created_at),
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
  ];

  return (
    <Table
      dataSource={props.batches || []}
      columns={columns}
      {...props}
      loading={{
        indicator: LoadingIcon,
        size: 'large',
        spinning: props.loading || false,
      }}
      bordered={false}
      rowKey={(row, index) => index}
      scroll={{ x: true }}
    />
  );
};

BatchList.propTypes = {
  batches: PropTypes.array,
  loading: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(BatchList);
